var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "modal-search-customer-level",
      "title": "選擇會員等級",
      "no-close-on-backdrop": ""
    },
    on: {
      "show": _vm.initializeTempCustomerLevels
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "w-100"
        }, [_c('div', {
          staticClass: "float-right"
        }, [_c('span', {
          staticClass: "mr-2 mdi mdi-chevron-left mdi-36px",
          class: _vm.meta.current_page == 1 ? 'text-muted' : '',
          on: {
            "click": _vm.prevPage
          }
        }), _c('span', {
          staticClass: "mr-5 mdi mdi-chevron-right mdi-36px",
          class: _vm.meta.current_page == _vm.meta.last_page ? 'text-muted' : '',
          on: {
            "click": _vm.nextPage
          }
        }), _c('b-button', {
          staticClass: "mr-2 ml-5",
          attrs: {
            "variant": "danger",
            "size": "sm"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_vm._v(" 取消 ")]), _c('b-button', {
          attrs: {
            "variant": "primary",
            "size": "sm"
          },
          on: {
            "click": _vm.submitSelectedCustomerLevels
          }
        }, [_vm._v(" 確定 ")])], 1)])];
      },
      proxy: true
    }])
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋名字、描述"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getCustomerLevelsList.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.getCustomerLevelsList
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1), _vm.isLoading ? _c('div', {
    staticClass: "text-center mt-3 mb-3 loading-spinner"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _vm.customerLevels.length > 0 ? _c('div', {
    staticClass: "mt-3 mb-3"
  }, _vm._l(_vm.customerLevels, function (customerLevel) {
    return _c('div', {
      key: customerLevel.id,
      staticClass: "d-flex align-items-center py-2 customerLevel-item",
      on: {
        "click": function click($event) {
          return _vm.handleSelected(customerLevel);
        }
      }
    }, [_c('div', {
      staticClass: "mr-auto text-nowrap text-truncate ml-2"
    }, [_c('div', {
      staticClass: "font-weight-bold"
    }, [_vm._v(" " + _vm._s(customerLevel.name) + " ")]), _c('div', [_vm._v(" " + _vm._s(customerLevel.description) + " ")]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" " + _vm._s(_vm.format(new Date(customerLevel.start_at), 'yyyy-MM-dd HH:mm')) + " ~ " + _vm._s(_vm.format(new Date(customerLevel.end_at), 'yyyy-MM-dd HH:mm')) + " ")])]), _c('div', {
      staticClass: "mx-2"
    }, [_vm.selectedCustomerLevelsIdList.includes(customerLevel.id) ? _c('span', {
      staticClass: "mdi mdi-check-circle mdi-24px"
    }) : _vm._e()])]);
  }), 0) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }